const appearAnimationStore = new Map();
const appearComplete = new Map();

export { appearAnimationStore, appearComplete };
